exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-card-padding {\n  margin: 0 auto;\n  width: 100%;\n  min-height: 564.8px;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.error-icon {\n  color: #cb6f67;\n  margin: 0 auto; }\n\n.success-icon {\n  color: #c4d69b;\n  margin: 0 auto; }\n\n.headline {\n  color: #1594A6;\n  margin-top: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/forgot-password/forgot-password.component.scss
// module id = ../../../../../src/app/components/forgot-password/forgot-password.component.scss
// module chunks = main